export const handlerSelectOrders = (
  value: any,
  tag: string,
  setSelectorList: (evt: any) => void
) => {
  setSelectorList({ tag: tag, value: value });
};
